import React, { useState } from 'react';
import { Grid2 as Grid, Typography, Button, Collapse } from '@mui/material';
import { withStyles } from '@mui/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import { COLORS } from '../../../utils/Application_Constants';

const styles = () => ({
    wrapper: {
        '&:not(:first-child)': {
            borderTop: `1px solid ${COLORS.LT_MIDNIGHTSTEEL}`,
        },
        '&:last-child': {
            borderBottom: `1px solid ${COLORS.LT_MIDNIGHTSTEEL}`,
        },
    },
    button: {
        width: '28em',
        padding: '1em',
        position: 'initial',
        '&:hover': { backgroundColor: 'transparent' },
        '&:focus': { backgroundColor: 'transparent' },
        '&:active': { backgroundColor: 'transparent' },
        borderRadius: '0',
        justifyContent: 'space-between',
    },
    content: {
        paddingLeft: '1em',
    },
    clear: {
        textDecoration: 'underline',
        paddingLeft: '1em',
    },
});

const CollapsibleFilterWrapper = ({ classes, children, label, onReset }) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={classes.wrapper}>
            <Button
                className={classes.button}
                style={{ borderBottom: 'none' }}
                disableRipple
                onClick={() => setExpanded(!expanded)}
                aria-expanded={expanded}
                aria-controls="panel1-content"
                endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            >
                <Grid container alignItems="center" spacing={1}>
                    <Grid>
                        <Typography>{label}</Typography>
                    </Grid>
                    {expanded && (
                        <Grid>
                            <Typography
                                variant="body2"
                                className={classes.clear}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onReset();
                                }}
                            >
                                Reset
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </Button>
            <Collapse in={expanded} className={classes.content}>
                {children}
            </Collapse>
        </div>
    );
};

export default withStyles(styles)(CollapsibleFilterWrapper);
